export var MQTT_EVENTS;
(function (MQTT_EVENTS) {
    MQTT_EVENTS["TERMINATED"] = "CobrowsingTerminatedEvent";
    MQTT_EVENTS["VIEW_REQUESTED"] = "CobrowsingViewRequestedEvent";
    MQTT_EVENTS["CONTROL_REQUESTED"] = "CobrowsingControlRequestedEvent";
    MQTT_EVENTS["VIEW_ACCEPTED"] = "CobrowsingViewAcceptedEvent";
    MQTT_EVENTS["CONTROL_ACCEPTED"] = "CobrowsingControlAcceptedEvent";
    MQTT_EVENTS["CONTROL_REVOKED"] = "CobrowsingControlRevokedEvent";
    MQTT_EVENTS["VIEW_REVOKED"] = "CobrowsingViewRevokedEvent";
    MQTT_EVENTS["ACCESS_DENIED"] = "CobrowsingAccessDeniedEvent";
    MQTT_EVENTS["PAGE_UPDATED"] = "CobrowsingPageUpdatedEvent";
    MQTT_EVENTS["OPTION_UPDATED"] = "CobrowsingOptionUpdatedEvent";
    MQTT_EVENTS["CURSOR_UPDATED"] = "CobrowsingCursorUpdatedEvent";
    MQTT_EVENTS["INPUT_UPDATED"] = "CobrowsingInputUpdatedEvent";
    MQTT_EVENTS["SENDER_UPDATED"] = "CobrowsingSenderUpdatedEvent";
    MQTT_EVENTS["RECONNECTED"] = "CobrowsingReconnectedEvent";
    MQTT_EVENTS["CREATED"] = "CobrowsingSessionCreatedEvent";
})(MQTT_EVENTS || (MQTT_EVENTS = {}));
export var COBROWSER_PERMISSION;
(function (COBROWSER_PERMISSION) {
    COBROWSER_PERMISSION["VIEW"] = "view";
    COBROWSER_PERMISSION["CONTROL"] = "control";
})(COBROWSER_PERMISSION || (COBROWSER_PERMISSION = {}));
/****
 * typings for requests
 ****/
export var API_COMMAND;
(function (API_COMMAND) {
    API_COMMAND["CREATE_SESSION"] = "CreateCobrowsingSession";
    API_COMMAND["OPTION_ENABLE"] = "EnableCobrowsingOption";
    API_COMMAND["OPTION_DISABLE"] = "DisableCobrowsingOption";
    API_COMMAND["VIEW_REQUEST"] = "RequestCobrowsingView";
    API_COMMAND["CONTROL_REQUEST"] = "RequestCobrowsingControl";
    API_COMMAND["TERMINATE"] = "TerminateCobrowsingSession";
    API_COMMAND["VIEW_ACCEPT"] = "AcceptCobrowsingView";
    API_COMMAND["CONTROL_ACCEPT"] = "AcceptCobrowsingControl";
    API_COMMAND["VIEW_REVOKE"] = "RevokeCobrowsingView";
    API_COMMAND["CONTROL_REVOKE"] = "RevokeCobrowsingControl";
    API_COMMAND["VIEW_DENY"] = "DenyCobrowsingView";
    API_COMMAND["CONTROL_DENY"] = "DenyCobrowsingControl";
    API_COMMAND["PAGE_UPDATE"] = "UpdateCobrowsingPage";
    API_COMMAND["CURSOR_UPDATE"] = "UpdateCobrowsingCursor";
    API_COMMAND["INPUT_UPDATE"] = "UpdateCobrowsingInput";
    API_COMMAND["RESUME"] = "ResumeCobrowsingSession";
    API_COMMAND["RECONNECT"] = "ReconnectCobrowsingSession";
})(API_COMMAND || (API_COMMAND = {}));
export var FilterType;
(function (FilterType) {
    /** * no filtering */
    FilterType[FilterType["None"] = 0] = "None";
    /** will filter and be displayed as so */
    FilterType[FilterType["Display"] = 1] = "Display";
    /** the node will not be displayed, but will still exist in dom */
    FilterType[FilterType["NoDisplay"] = 2] = "NoDisplay";
    /** display with random data */
    FilterType[FilterType["DisplayRandomized"] = 3] = "DisplayRandomized";
})(FilterType || (FilterType = {}));
//# sourceMappingURL=model.js.map